<template>
    <div :class="['switch', { 'on': isOn }]" @click="toggleSwitch">
        <div class="toggle"></div>
    </div>
</template>

<script>
export default {
    name: 'SwitchComponent',
    props: {
        value: Boolean,
        callback: Function,
    },
    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                this.isOn = newValue;
            },
        },
    },
    data() {
        return {
            isOn: false,
        };
    },
    methods: {
        toggleSwitch() {
            this.isOn = !this.isOn;
            this.callback(this.isOn);
        },
    },
};
</script>

<style scoped>
.switch {
    width: 50px;
    height: 25px;
    background-color: lightgrey;
    border-radius: 15px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.3s;
}

.switch.on {
    background-color: red;
}

.toggle {
    width: 23px;
    height: 23px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition: left 0.3s;
}

.switch.on .toggle {
    left: 26px;
}
</style>
